import api from './api'

const BASE = '/users/users'

export const usersService = {
  list: (params = {}) => api.get(`${BASE}/`, { params }).then((r) => r.data),
  get: (id) => api.get(`${BASE}/${id}/`).then((r) => r.data),
  create: (data) => api.post(`${BASE}/`, data).then((r) => r.data),
  update: (id, data) => api.patch(`${BASE}/${id}/`, data).then((r) => r.data),
  delete: (id) => api.delete(`${BASE}/${id}/`),
  me: () => api.get(`${BASE}/me/`).then((r) => r.data),
  // i professionisti dello studio (chi si può mettere in agenda)
  // di default solo i professionisti disponibili: i contesti di pianificazione
  // (calendario, agenda, assegnazioni) non devono elencare account di servizio
  // o persone non operative. Passare {is_available: undefined} per averli tutti.
  listProfessionals: (params = {}) =>
    api
      .get('/users/professionals/', {
        params: { page_size: 100, is_available: true, ...params },
      })
      .then((r) => r.data.results || r.data),
  updateMe: (data) => api.patch(`${BASE}/me/`, data).then((r) => r.data),
  changePassword: (oldPassword, newPassword) =>
    api
      .post(`${BASE}/change_password/`, {
        old_password: oldPassword,
        new_password: newPassword,
      })
      .then((r) => r.data),
  resetPasswordByAdmin: (userId, newPassword) =>
    api
      .post(`${BASE}/${userId}/reset_password/`, { new_password: newPassword })
      .then((r) => r.data),
  requestPasswordReset: (email) =>
    api
      .post('/users/password-reset/request/', { email })
      .then((r) => r.data),
  confirmPasswordReset: (token, newPassword) =>
    api
      .post('/users/password-reset/confirm/', {
        token,
        new_password: newPassword,
      })
      .then((r) => r.data),
}

export const ROLES = [
  { value: 'admin', label: 'Amministratore' },
  { value: 'manager', label: 'Project Manager' },
  { value: 'staff', label: 'Staff' },
  { value: 'client', label: 'Cliente' },
]

export function roleLabel(role) {
  return ROLES.find((r) => r.value === role)?.label || role
}

export function isAdminUser(user) {
  if (!user) return false
  return user.role === 'admin' || user.is_staff === true
}

export function canSeeCompanyDashboard(user) {
  if (!user) return false
  return user.role === 'admin' || user.role === 'manager' || user.is_staff === true
}

export function isManagerUser(user) {
  if (!user) return false
  return user.role === 'manager'
}

// Vocabolario del controllo di gestione (lo stesso di RoleGuard, del menu e
// della dashboard direzionale). "Socio" = ruolo admin, NON is_staff: un
// superuser tecnico senza ruolo admin non eredita la visibilità direzionale
// sui compensi soci (coerente con apps/controlling/permissions.py).
export function isPartnerUser(user) {
  return user?.role === 'admin'
}

// "PM" = ruolo manager: stessa cosa di isManagerUser, col nome dei ruoli
// logici del controllo di gestione.
export const isPmUser = isManagerUser

// Vede e gestisce TUTTI i preventivi dello studio: admin, manager o utente
// con delega esplicita (flag can_manage_estimates). Non implica accesso al
// resto del cruscotto aziendale (commesse, fatture, ecc.).
export function canManageEstimates(user) {
  if (!user) return false
  return (
    user.role === 'admin' ||
    user.role === 'manager' ||
    user.is_staff === true ||
    user.can_manage_estimates === true
  )
}

// Vede le fatture dello studio: admin, manager o utente con delega esplicita
// (flag can_view_invoices, in sola lettura). Non implica accesso al resto
// del cruscotto aziendale (preventivi, ingaggi, ecc.).
export function canViewInvoices(user) {
  if (!user) return false
  return (
    user.role === 'admin' ||
    user.role === 'manager' ||
    user.is_staff === true ||
    user.can_view_invoices === true
  )
}

// Pianifica appuntamenti anche per altre persone (le aggiunge come
// partecipanti): admin, manager o utente con delega esplicita
// (flag can_manage_appointments).
export function canManageAppointments(user) {
  if (!user) return false
  return (
    user.role === 'admin' ||
    user.role === 'manager' ||
    user.is_staff === true ||
    user.can_manage_appointments === true
  )
}
